module.exports = __webpack_public_path__ + "images/4a1ae75ac4ab74f7c84c8fcd420dd615.png";